// lib/rozliczenia/rok.ts — pomocniki widoku ROZLICZEŃ ROCZNYCH (bez Reacta, bez sieci).
// Rok rozliczeniowy (wrzesień–sierpień), jego miesiące i metryki liczy SERWER
// (`server/lib/rozliczenia/rok.js`); tu tylko etykiety i nawigacja po latach.

/** Pierwszy rok rozliczeniowy z danymi w replice CRM (dane od września 2025). */
export const PIERWSZY_ROK_ROZLICZENIOWY = 2025;

/** Skróty miesięcy w kolejności roku rozliczeniowego (IX..VIII). */
export const MIESIACE_ROKU_KROTKO = ['wrz', 'paź', 'lis', 'gru', 'sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie'] as const;

/** „2026/2027”. */
export function etykietaRoku(start: number): string {
  return `${start}/${start + 1}`;
}

/** Lata rozliczeniowe do wyboru: od pierwszego z danymi do bieżącego (+1, żeby było widać, że następny jest pusty). */
export function lataRozliczeniowe(dzisiaj = new Date()): number[] {
  const biezacy = dzisiaj.getMonth() + 1 >= 9 ? dzisiaj.getFullYear() : dzisiaj.getFullYear() - 1;
  return Array.from({ length: biezacy - PIERWSZY_ROK_ROZLICZENIOWY + 1 }, (_, i) => PIERWSZY_ROK_ROZLICZENIOWY + i);
}

/** Procent z ułamka z jednym miejscem po przecinku: 0.7512 → „75,1%”; `null` → „—”. */
export function procent(ulamek: number | null | undefined, miejsca = 1): string {
  if (ulamek === null || ulamek === undefined || !Number.isFinite(ulamek)) return '—';
  return `${(ulamek * 100).toLocaleString('pl-PL', { minimumFractionDigits: miejsca, maximumFractionDigits: miejsca })}%`;
}
